import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Subject, throwError } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AppService {
  fast_api_url = environment.HOST.FAST_API_URL;
  
  makeFlexBasedUi: Subject<boolean> = new Subject<boolean>();
  spotlightSearchCandidate: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private _http: HttpClient
  ) { }

  globalSearch(params: { query: string, required_type?: string, page?: number, size?: number }) {
    return this._http.get<HttpResponse<any>>(this.fast_api_url + `/search/global-search`, {
      params: params,
      observe: 'response'
    }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error))
    );
  }
}